export class BaseApiService {
    constructor(token, apiUrl) {
        this.objectToFormData = (obj, rootName, ignoreList) => {
            var formData = new FormData();
            const appendFormData = (data, root) => {
                if (!ignore(root)) {
                    root = root || "";
                    if (data instanceof File) {
                        formData.append(root, data);
                    }
                    else if (Array.isArray(data)) {
                        for (var i = 0; i < data.length; i++) {
                            appendFormData(data[i], root + "[" + i + "]");
                        }
                    }
                    else if (typeof data === "object" && data) {
                        for (let key in data) {
                            if (data.hasOwnProperty(key)) {
                                if (root === "") {
                                    appendFormData(data[key], key);
                                }
                                else {
                                    appendFormData(data[key], root + "." + key);
                                }
                            }
                        }
                    }
                    else {
                        if (data !== null && typeof data !== "undefined") {
                            formData.append(root, data);
                        }
                    }
                }
            };
            function ignore(root) {
                return (Array.isArray(ignoreList) &&
                    ignoreList.some(function (x) {
                        return x === root;
                    }));
            }
            appendFormData(obj, rootName);
            return formData;
        };
        this.token = token;
        this.apiUrl = apiUrl;
    }
    getApiUrl(url) {
        return `${this.apiUrl}${url}`;
    }
    headers() {
        const headers = new Headers();
        if (this.token) {
            headers.append("X-ApiKey", this.token);
        }
        return headers;
    }
    get(url) {
        return fetch(this.getApiUrl(url), {
            headers: this.headers(),
            method: "GET",
        }).then((x) => x.json());
    }
    submitForm(url, data, method) {
        const form = this.objectToFormData(data, "", false);
        return fetch(this.getApiUrl(url), {
            headers: this.headers(),
            method: method,
            body: form,
        }).then((x) => x.json());
    }
    post(url, data) {
        return this.submitForm(url, data, "POST");
    }
    put(url, data) {
        return this.submitForm(url, data, "PUT");
    }
    delete(url) {
        return this.submitForm(url, null, "DELETE");
    }
}
